import React from "react";
import { Container, Tabs, Tab } from "react-bootstrap";
import { useSuperState } from "helpers/hooks";

import QueueTabs from "pages/dashboard/queue/tabs";
import { FormattedMessage } from "react-intl";

export const Queue = props => {

    const [state, setState] = useSuperState({
        active_key: 'active'
    });

    const { active_key } = state;

    const setActiveKey = active_key => setState({ active_key });

    return (
        <Container className="queue">
            <h1>
                <FormattedMessage
                    defaultMessage="Queue"
                    id="label.queue"
                />
            </h1>

            <hr/>

            <Tabs
                activeKey={active_key}
                onSelect={setActiveKey}
                className="mb-3"
                mountOnEnter
                unmountOnExit
                >
                <Tab eventKey="active" title="Active">
                    <QueueTabs.Active />
                </Tab>
                <Tab eventKey="history" title="History">
                    <QueueTabs.History />
                </Tab>
            </Tabs>

        </Container>
    );
};